import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import { useToasts } from "react-toast-notifications";
import ImageUploader from "react-images-upload";
import {
  changeData,
  fetchAnagraficaWithResult,
  uploadFile,
} from "../../helpers/dbOperations";
import { Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import {
  Box,
  Button,
  makeStyles,
  Paper,
  Tabs,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { fetchAnagrafica, fetchSendCartData } from "../../helpers/dbOperations";
import CustomerModal from "./modals/modalCustomer";
import { Modal } from "react-bootstrap";
import { Article } from "./animationList";
import ReactLoading from "react-loading";
import { Icon } from "@mui/material";

const MyShippings = ({ location, userData, saveUser }) => {
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    mymodal: {
      width: "20vw" /* Occupy the 90% of the screen width */,
      maxWidth: "20vw",
    },
  });
  var strings = require("../../translations/italian.json");
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const [docs, setDocs] = useState([]);
  const [showModalCustomer, setShowModalCustomer] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [customerArray, setCustomerArray] = useState([]);
  const [onClick, setOnClick] = useState(0);
  const [idCli, setIdCli] = useState(0);
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);
  const [wait, setWait] = useState(false);
  var informazioni = global.informazioni;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalUrl, setModalUrl] = useState("");
  const [modalTitleShipping, setModalTitleShipping] = useState("");
  var _sper = sessionStorage.getItem("personal");
  if (_sper === "undefined") _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const SegliAnagrafica = (risultatoAnagrafica) => {
    setModalTitle("Scegli il cliente");
    risultatoAnagrafica.Anagrafica.map((item) => {
      item.value = item.RagSoc;
      item.id = item.IdCli;
      return item;
    });
    setCustomerArray(risultatoAnagrafica.Anagrafica);
    setOnClick(1);
    setShowModalCustomer(true);
  };
  const caricaAnagrafica = async () => {
    //console.log("carica anagrafica")
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var indexAnagraficaScelta = 0;
    var indexSede = 0;
    var risultatoAnagrafica = {};
    fetchAnagraficaWithResult({ username, password })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result)
        if (!result || !result.Anagrafica) return result;

        if (result.Anagrafica.length > 1) {
          indexAnagraficaScelta = SegliAnagrafica(result);
        } else {
          setIdCli(result.Anagrafica[0].IdCli);
          setCustomerArray(result.Anagrafica);
        }
        return result;
      });
  };
  useEffect(() => {
    setShowModalCustomer(false);
    if (userData.user.user && idCli != 0) {
      var username = userData.user.user.username;
      var password = userData.user.user.password;
      var body = JSON.stringify({ username, password, IDCli: idCli });

      var endpoint = global.endpoint + "pegaso/getDocCli";
      fetch(endpoint, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        body: body,
        withCredentials: false,
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result.Docs);
          setDocs(result.Docs);
        });
    }
  }, [idCli]);

  useEffect(() => {
    try {
      if (!userData.user.user.IDCli || userData.user.user.IDCli == 0) {
        //console.log("Agente")
        caricaAnagrafica();
      } else if (userData.user.user && userData.user.user.IDCli != 0) {
        var username = userData.user.user.username;
        var password = userData.user.user.password;
        var body = JSON.stringify({
          username,
          password,
          IDCli: userData.user.user.IDCli,
        });

        var endpoint = global.endpoint + "pegaso/getDocCli";
        fetch(endpoint, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
          }),
          body: body,
          withCredentials: false,
        })
          .then((res) => res.json())
          .then((result) => {
            console.log(result.Docs);
            setDocs(result.Docs);
          });
      }
    } catch (err) {}
  }, []);

  function downloadFile(LIdDoc, CodSezVen, datDoc, numOrd) {
    setWait(true);
    var endpoint = global.endpoint + "pegaso/webAppDocPDF";
    var body = JSON.stringify({ IdDoc: LIdDoc });
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
      withCredentials: false,
    })
      .then((res) => res.blob())
      .then((blob) => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${CodSezVen}_N°${numOrd}_${datDoc}.pdf`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        setWait(false);
      });
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        style={{ width: "100%" }}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function openWindowWithPost(url, data) {
    // Il nome del popup/tab. È cruciale che sia lo stesso sia nel form.target
    // che nel secondo argomento di window.open().
    const popupName = "print_popup";

    // Opzioni della finestra popup (dimensioni, scrollbar, ecc.)
    // Questi parametri sono rispettati solo se il browser decide di aprire una vera nuova finestra/popup,
    // e non una semplice nuova tab che ignora le dimensioni.
    const windowFeatures = "width=1000,height=800,scrollbars=yes,resizable=yes";

    // 1. Apri la finestra popup VUOTA PRIMA di fare il submit del form.
    // Questo è fondamentale: prepara il target per il POST.
    // L'URL 'about:blank' è usato per aprire una finestra vuota.
    const newWindow = window.open("about:blank", popupName, windowFeatures);

    // Gestione di un eventuale blocco popup del browser.
    // Se newWindow è null o undefined, il popup è stato bloccato.
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      alert(
        "Il popup è stato bloccato dal browser. Abilita i popup per questo sito."
      );
      return; // Esci dalla funzione se il popup è bloccato.
    }

    // 2. Crea un form temporaneo per inviare i dati via POST.
    const form = document.createElement("form");
    form.target = popupName; // Imposta il target del form al nome del popup appena aperto.
    form.method = "POST";
    form.action = url;
    form.style.display = "none"; // Nascondi il form.

    // 3. Aggiungi i dati dinamici al form come input nascosti.
    for (const key in data) {
      // Usa hasOwnProperty per evitare proprietà ereditate dalla catena di prototipi.
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      }
    }

    // 4. Appendi il form al body, sottomettilo e rimuovilo immediatamente.
    // Questo deve avvenire in modo sincrono e direttamente dall'azione utente
    // (es. un click) per non essere bloccato dai filtri anti-popup.
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    // Focus sulla nuova finestra per assicurarsi che venga visualizzata.
    newWindow.focus();
  }
  const handleOpenModal = (url, data) => {
    // Questi dati verrebbero passati dalla tua logica applicativa
    const dataToSend = {
      idSpedizione: "XYZ789",
      cliente: "Giulia Verdi",
      prodotto: "Smartphone",
    };
    const urlToLoad = "https://httpbin.org/post"; // Sostituisci con il tuo endpoint reale
    // Per test, httpbin.org/post è utile per vedere i dati POST ricevuti.

    setModalData(data);
    setModalUrl(url);
    setModalTitle(`Dettagli Spedizione`);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Resetta i dati se necessario per evitare di mostrarli alla prossima apertura
    setModalData({});
    setModalUrl("");
    setModalTitle("");
  };
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.shippings} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.shippings + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb 
        <Breadcrumb />*/}

        <CustomerModal
          style={{ zIndex: 10000 }}
          show={showModalCustomer}
          onHide={() => {
            setShowModalCustomer(false);
            setinCaricamentoCheckOut(false);
          }}
          array={customerArray}
          title={modalTitle}
          onClick={setIdCli}
        />
        <div className="login-register-area pt-20">
          <div className="container">
            <div className="row">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
              />
              <Modal
                show={wait}
                transparent={true}
                dialogClassName={classes.mymodal}
              >
                <div style={{ justifyContent: "center", alignSelf: "center" }}>
                  <Article key={"spinningBubbles"}>
                    <ReactLoading type={"spinningBubbles"} color="#ABABAB" />
                  </Article>
                </div>
              </Modal>
              {(!userData.user.user?.IDCli ||
                userData.user.user?.IDCli == 0) && (
                <div>
                  <Button onClick={() => caricaAnagrafica()}>
                    {" "}
                    Cambia cliente{" "}
                  </Button>
                </div>
              )}
              {/*personal.IDLis && <div style={{justifyContent:"center", display:"flex",width:"100%", marginBottom:"5%"}}>
                {personal.IDLis== 34 && <a href="/files/listino_4super.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                {personal.IDLis== 33 && <a href="/files/listino_5top.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                </div>
        */}
              <div class="alert alert-info" role="alert">
                <h4 class="alert-heading">Informazioni spedizioni:</h4>
                <p>
                  {" "}
                  In questa sezione puoi monitorare le tue spedizioni. Per
                  visualizzare il tracking di una spedizione specifica, clicca
                  sull'icona &nbsp;<Icon>local_shipping</Icon>
                  &nbsp;.
                </p>
              </div>
              <TabPanel value={value} index={0}>
                <div style={{}}>
                  <MaterialTable
                    actions={[
                      (rowData) => ({
                        icon: "local_shipping",
                        tooltip: "Traccia la spedizione",
                        hidden:
                          !rowData.DesVet?.includes("GLS") &&
                          !rowData.DesVet?.includes("BRT") &&
                          !rowData.NUMCON,
                        onClick: (event, rowData) => {
                          let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
                          if (
                            rowData.DesVet?.includes("GLS") ||
                            rowData.DesVet?.includes("BRT") ||
                            rowData.NUMCON
                          ) {
                            if (rowData.DesVet?.includes("GLS")) {
                              openWindowWithPost(
                                "https://www.gls-italy.com/it/servizi-per-destinatari/dettaglio-spedizione",
                                {
                                  filtro_codice: 0,
                                  mode: "search",
                                  numero_spedizione:
                                    "SA4431" +
                                    rowData.numOrd +
                                    "/" +
                                    rowData.datDoc.slice(-2),
                                  pagina: 1,
                                  tipo_codice: "ddt",
                                }
                              );
                              //window.open("https://gls-group.com/app/service/open/rest/IT/it/rstt001?match=SA4431"+rowData.numOrd+"&type=DDT&caller=witt002&millis=1657112781442", "Tracking", params)
                            }
                            if (rowData.DesVet?.includes("BRT")) {
                              openWindowWithPost(
                                "https://vas.brt.it/vas/sped_ricDocMit_load.hsm",
                                {
                                  DocMit:
                                    rowData.datDoc.slice(-2) + rowData.numOrd,
                                  KSU: 1221302,
                                }
                              );
                              //window.open("https://gls-group.com/app/service/open/rest/IT/it/rstt001?match=SA4431"+rowData.numOrd+"&type=DDT&caller=witt002&millis=1657112781442", "Tracking", params)
                            }
                            if (rowData.NUMCON) {
                              /*openWindowWithPost(
                                "https://vas.brt.it/vas/sped_ricDocMit_load.hsm",
                                {
                                  DocMit:
                                    rowData.datDoc.slice(-2) + rowData.numOrd,
                                  KSU: 1221302,
                                }
                              );*/
                              window.open(
                                "https://track.spedisci.online/" +
                                  rowData.NUMCON,
                                "Tracking"
                              );
                            }
                          } else {
                            alert(
                              "Spedizione non disponibile o previsto RITIRO IN SEDE"
                            );
                          }
                        },
                      }),
                    ]}
                    localization={{
                      pagination: {
                        labelDisplayedRows: "{from}-{to} di {count}",
                        labelRowsPerPage: "{25,100}",
                        labelRowsSelect: "righe",
                      },
                      toolbar: {
                        nRowsSelected: "{0} riga(e) selezionate",
                        searchTooltip: "Ricerca",
                        searchPlaceholder: "Ricerca",
                      },
                      header: {
                        actions: "Traccia",
                      },
                      body: {
                        emptyDataSourceMessage:
                          "Nessuna spedizione da visualizzare",
                        filterRow: {
                          filterTooltip: "Filtro",
                        },
                      },
                    }}
                    style={{ width: "1200" }}
                    columns={
                      global.aziendaID == 2
                        ? [
                            {
                              title: "Num. documento",
                              field: "numOrd",
                              type: "text",
                            },
                            { title: "Tipo", field: "CodSezVen", type: "text" },
                            { title: "Data documento", field: "datDoc" },
                            /*{
                              title: "Tot. imponibile",
                              field: "impDoc",
                              type: "currency",
                              currencySetting: {
                                locale: "it",
                                currencyCode: "eur",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            },
                            {
                              title: "Tot. iva",
                              field: "ivaDoc",
                              type: "currency",
                              currencySetting: {
                                locale: "it",
                                currencyCode: "eur",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            },*/
                            {
                              title: "Tot.",
                              field: "totDoc",
                              type: "currency",
                              currencySetting: {
                                locale: "it",
                                currencyCode: "eur",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            },
                            { title: "Pagato", field: "Pagato", type: "text" },
                          ]
                        : [
                            {
                              title: "Num. documento",
                              field: "numOrd",
                              type: "text",
                            },
                            { title: "Tipo", field: "CodSezVen", type: "text" },
                            { title: "Data documento", field: "datDoc" },
                            /*{
                              title: "Tot. imponibile",
                              field: "impDoc",
                              type: "currency",
                              currencySetting: {
                                locale: "it",
                                currencyCode: "eur",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            },
                            {
                              title: "Tot. iva",
                              field: "ivaDoc",
                              type: "currency",
                              currencySetting: {
                                locale: "it",
                                currencyCode: "eur",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            },*/
                            {
                              title: "Tot.",
                              field: "totDoc",
                              type: "currency",
                              currencySetting: {
                                locale: "it",
                                currencyCode: "eur",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            },
                          ]
                    }
                    data={JSON.parse(
                      JSON.stringify(
                        docs.filter((doc) => {
                          return (
                            !doc.FlgOrdine &&
                            (doc.DesVet?.includes("GLS") ||
                              doc.DesVet?.includes("BRT") ||
                              doc.NUMCON)
                          );
                        })
                      )
                    )}
                    title="Spedizioni"
                    options={{
                      pageSize: 10,
                      actionsColumnIndex: -1,
                    }}
                  />
                </div>
              </TabPanel>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

MyShippings.propTypes = {
  location: PropTypes.object,
  userData: PropTypes.object,
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData ? state.userData : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyShippings);
